import { GET_GOODS } from "constants/goods";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_GOODS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
